import { Component, Output, Input, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteHelper } from '@app/@shared/utils/route-helper';
import { RecentViewTable, RecentViewTableRow } from '@shared/models/user-view-history/recent-view-table.model';

@Component({
    selector: 'app-recent-view-table',
    templateUrl: './recent-view-table.component.html',
    styleUrls: ['./recent-view-table.component.scss'],
    standalone: false
})
export class RecentViewTableComponent {
  @Input() table: RecentViewTable;
  @Output() clickRow = new EventEmitter<RecentViewTableRow>();

  constructor(private router: Router, private route: ActivatedRoute){}

  onClickRow(row: RecentViewTableRow, e: Event) {
    e.preventDefault();

    this.clickRow.emit(row);
  }

  public createRowUrl(r: RecentViewTableRow): string {
    const urlObj = new URL(r.url, window.location.origin);

    const path = urlObj.pathname;
    const queryParams: { [key: string]: string } = {};
    urlObj.searchParams.forEach((value, key) => {
      queryParams[key] = value;
    });

    const fragment = urlObj.hash.replace('#', '');
    return this.router.serializeUrl(
      this.router.createUrlTree([path], {
        queryParams,
        fragment,
        relativeTo: RouteHelper.getModuleRouteOrShell(this.route)
      })
    );
  }
}
